import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('./views/Index.vue'),
      meta: {
        redHeader: true,
      },
    },
    {
      path: '/lokale',
      name: 'Locals',
      component: () => import('./views/Locals.vue'),
      meta: {
        redHeader: false,
      },
    },
    {
      path: '/idea',
      name: 'Idea',
      component: () => import('./views/Idea.vue'),
      meta: {
        redHeader: false,
      },
    },
    {
      path: '/kim-jestesmy',
      name: 'WhoWeAre',
      component: () => import('./views/WhoWeAre.vue'),
      meta: {
        redHeader: true,
      },
    },
    {
      path: '/punkty-poboru',
      name: 'DonationPoints',
      component: () => import('./views/DonationPoints.vue'),
      meta: {
        redHeader: false,
      },
    },
    {
      path: '/kontakt',
      name: 'Contact',
      component: () => import('./views/Contact.vue'),
      meta: {
        redHeader: false,
        },
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import('./views/FAQ.vue'),
        meta: {
          redHeader: false,
      },
    },
  ],
});
